import { render, staticRenderFns } from "./RemoveVideoInstructionsDialog.vue?vue&type=template&id=3028b97f&scoped=true"
import script from "./RemoveVideoInstructionsDialog.vue?vue&type=script&lang=js"
export * from "./RemoveVideoInstructionsDialog.vue?vue&type=script&lang=js"
import style0 from "./RemoveVideoInstructionsDialog.vue?vue&type=style&index=0&id=3028b97f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3028b97f",
  null
  
)

export default component.exports